import { Link, createRootRoute, HeadContent, Scripts } from "@tanstack/react-router";
import appCss from "../styles.css?url";
import { I18nProvider } from "@/lib/i18n";
import { AuthProvider } from "@/lib/auth";
import { Toaster } from "@/components/ui/sonner";

const jgyEmbedded = import.meta.env.VITE_JGY_EMBEDDED === "true";

function RootShell({ children }: { children: React.ReactNode }) {
  const app = (
    <I18nProvider>
      <AuthProvider>
        {children}
        <Toaster position="top-center" />
      </AuthProvider>
    </I18nProvider>
  );
  if (jgyEmbedded) {
    return (
      <>
        <HeadContent />
        {app}
        <Scripts />
      </>
    );
  }
  return (
    <html lang="en">
      <head>
        <HeadContent />
      </head>
      <body>
        {app}
        <Scripts />
      </body>
    </html>
  );
}

function NotFoundComponent() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-4">
      <div className="max-w-md text-center">
        <h1 className="font-serif text-7xl font-bold text-foreground">404</h1>
        <h2 className="mt-4 font-serif text-xl font-semibold text-foreground">Page not found</h2>
        <p className="mt-2 text-sm text-muted-foreground">
          The page you're looking for doesn't exist.
        </p>
        <div className="mt-6">
          <Link to="/" className="btn-primary">
            Go home
          </Link>
        </div>
      </div>
    </div>
  );
}

export const Route = createRootRoute({
  head: () => ({
    meta: [
      { charSet: "utf-8" },
      { name: "viewport", content: "width=device-width, initial-scale=1" },
      { title: "Jain Gaurav Yatra — Together for Dharma, Seva & Unity" },
      {
        name: "description",
        content:
          "Stay connected with the Jain Gaurav Yatra — updates, routes, events, seva, announcements and community participation across Ahmedabad's 31 Jain Derasars.",
      },
    ],
    links: [
      // Empty data URI suppresses the favicon (and the default /favicon.ico request)
      { rel: "icon", href: "data:," },
      { rel: "stylesheet", href: appCss },
      { rel: "preconnect", href: "https://fonts.googleapis.com" },
      { rel: "preconnect", href: "https://fonts.gstatic.com", crossOrigin: "anonymous" },
      {
        rel: "stylesheet",
        href: "https://fonts.googleapis.com/css2?family=Lora:wght@500;600;700&family=Playfair+Display:wght@500;600;700;800&family=Inter:wght@400;500;600;700&family=Noto+Sans+Devanagari:wght@400;500;600;700&family=Noto+Sans+Gujarati:wght@400;500;600;700&display=swap",
      },
    ],
  }),
  shellComponent: RootShell,
  notFoundComponent: NotFoundComponent,
});
